import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import * as _ from 'lodash-es';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';

export interface ArchivesDialogOptions {
    title: string;
    text: string;
    hint?: string;
    valid: string;
    noConfirm: boolean;
    later?: string;
    rawText?: boolean;
    loading?: boolean;
    loadingText?: string;
}

@Component({
    selector: 'app-archives-dialog',
    templateUrl: './archives-dialog.component.html',
    styleUrls: ['./archives-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatProgressSpinner, MatDialogActions, MatButton, MatDialogClose, TranslatePipe]
})
export class ArchivesDialogComponent {
    dialogRef = inject<MatDialogRef<ArchivesDialogComponent>>(MatDialogRef);
    data = inject<ArchivesDialogOptions>(MAT_DIALOG_DATA);

    protected _defaultCtx: ArchivesDialogOptions = {
        title: '',
        text: '',
        hint: '',
        valid: 'YES',
        noConfirm: false,
        later: 'LATER',
        rawText: false,
        loading: false,
        loadingText: ''
    };

    public ctx: ArchivesDialogOptions;

    constructor() {
        this.ctx = _.merge(this._defaultCtx, _.cloneDeep(this.data));
    }
    

    onNoClick(): void {
        this.dialogRef.close();
    }
}
